<template>
  <div id="ServiceChoices">
    <!--Title-->
    <div class="row">
      <h4 class="col-xs-12 card-title csp-card-title">2017 Service Choices</h4>
    </div>
    <!--Text-->
    <div class="row">
      <div class="col-xs-12 ">
        <p class="card-text csp-banner-text">We recommend our full three-step service package, but if you want to choose only spring cleanup and/or summer maintenance, please do so here.</p>
      </div>                
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <form>
          
          <div class="row">
            <div class="col-xs-9">
              <div class="md-form">
                <p class="csp-service-id">Step 1 - Spring Cleanup</p>
                <p class="csp-service-text">Once the snow is gone, we will clean up winter debris, edge beds, turn mulch, cut perennials left over from winter, fertilize roses & hydrangeas, and apply pre-emergent to reduce weed growth.</p>
              </div>
            </div>
            <div class="col-xs-3">
                <input type="checkbox" id="csp-service1" v-model="springCleanup">
                <label for="csp-service1"></label>
            </div>
          </div>
          
          <div class="row">
            <div class="col-xs-9">
              <div class="md-form">
                <p class="csp-service-id">Step 2 - Summer Maintenance</p>
                <p class=" csp-service-text">Depending on the weather, at the end of May or in June, we will prune, edge, mulch, and apply another round of pre-emergent.</p>
              </div>
            </div>
            <div class="col-xs-3">
                <input type="checkbox" id="csp-service2" v-model="summerMaintenance" v-bind:disabled="!springCleanup">
                <label for="csp-service2"></label>
            </div>
          </div>
          
          <div class="row">
            <div class="col-xs-9">
              <div class="md-form">
                <p class="csp-service-id">Step 3 - Fall Cleanup</p>
                <p class="csp-service-text">In the fall months, we will cut perennials, touch up any pruning,  and apply one last round of pre-emergent.</p>
              </div>
            </div>
            <div class="col-xs-3">
                <input type="checkbox" id="csp-service3" v-model="fallCleanup" v-bind:disabled="!summerMaintenance">
                <label for="csp-service3"></label>
            </div>
          </div>
          
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ServiceChoices',
    computed: {
      springCleanup: {
        get: function () {
          return this.$store.getters.springCleanup
        },
        set: function (newValue) {
          if (!newValue) this.summerMaintenance = newValue
          this.$store.commit('updateServiceSelection', {'springCleanup': newValue})
        }
      },
      summerMaintenance: {
        get: function () {
          return this.$store.getters.summerMaintenance
        },
        set: function (newValue) {
          if (!newValue) this.fallCleanup = newValue
          this.$store.commit('updateServiceSelection', {'summerMaintenance': newValue})
        }
      },
      fallCleanup: {
        get: function () {
          return this.$store.getters.fallCleanup
        },
        set: function (newValue) {
          this.$store.commit('updateServiceSelection', {'fallCleanup': newValue})
        }
      }
    }
  }
</script>

<style scoped>
  
  .csp-service-id{
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 0.25vh;
  }
  
  .csp-service-text{
    text-align: justify;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.4em;
    color: rgba(0, 0, 0, 0.65);
  }

  /* All Mobile Sizes (devices and browser) */
  @media only screen and (max-width: 767px) {



  }
  
  @media only screen and (min-width: 480px) and (max-width: 767px) {

  }
  
  
  @media only screen and (max-width: 479px) {

  }
</style>



// WEBPACK FOOTER //
// ServiceChoices.vue?09cc0040